import React from "react";
import { useDispatch } from "react-redux";
import mernImage from "../../assets/images/mern.webp";
import { updateBlog } from "../../features/singleBlog/singleBlogSlice";


const Description = ({
  blog: { title, tags, isSaved, likes, description, image, id },
}) => {

    const dispatch = useDispatch();
  return (
    <main className="post">
      <img
        src={image}
        alt="githum"
        className="w-full rounded-md"
        id="lws-megaThumb"
      />
      <div>
        <h1 className="mt-6 text-2xl post-title" id="lws-singleTitle">
          {title}
        </h1>
        <div className="tags" id="lws-singleTags">
           {tags && tags.map((tag, i) => <span key={i}>#{tag}{i === tags.length - 1 ? "": ","} </span>)}
        </div>
        <div className="btn-group">
          {/*    <!-- handle like on button click --> */}
          <button className="like-btn" id="lws-singleLinks" onClick={() => dispatch(updateBlog({id, likes}))}>
            <i className="fa-regular fa-thumbs-up"></i> {likes}
          </button>
          {/*   <!-- handle save on button click -->
          <!-- use ".active" class and "Saved" text  if a post is saved, other wise "Save" --> */}
          <button
            className={`${
              isSaved ? "active" : ""
            } save-btn" id="lws-singleSavedBtn`}
            onClick={() => dispatch(updateBlog({id, isSaved}))}
          >
            <i className="fa-regular fa-bookmark"></i> {isSaved ? "Saved" : "Save"}
          </button>
        </div>
        <div className="mt-6">
          <p>{description}</p>
        </div>
      </div>
    </main>
  );
};

export default Description;
